exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mg-react-spinner{position:relative;height:100%}.mg-react-spinner .l-center{position:absolute;left:50%;top:50%;z-index:1}.mg-react-spinner__main{border:16px solid;border-radius:50%;border-top:16px solid;-webkit-animation:mg-spin 1s ease-out infinite;animation:mg-spin 1s ease-out infinite}@-webkit-keyframes mg-spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes mg-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./~/reactjs-spinner/dist/reactjs-spinner.css
// module id = 264
// module chunks = 0